import { createSelector } from "reselect";
import getUserAccount from "./get_user_account";

export const getUserId = createSelector([
  getUserAccount
], (account) => account?.userId || null)
